import React from 'react'

import { FormattedMessage } from '@divvy-web/i18n'

import MarketingLink from '@sputnik/components/MarketingContent/MarketingLink'
import { URL } from '@sputnik/resources/constants'

interface LearnMoreLinkProps {
  onClick?: () => void
}

const LearnMoreLink = ({ onClick }: LearnMoreLinkProps) => {
  return (
    <MarketingLink
      href={URL.CREDIT_IMPACT_LEARN_MORE}
      text={
        <FormattedMessage
          defaultMessage='Learn more here'
          id='sputnik.LearnMoreLink__aTxF6+'
        />
      }
      onClick={onClick}
    />
  )
}

export default LearnMoreLink
